import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { PanelUpdatePassword } from "../../Api/Panel/PanelUpdatePassword";
import { GetMyInfo } from "../../Api/Panel/GetMyInfo";

export default function Infopage() {
  const [copyRef, setCopyRef] = useState(false);
  const [userData, setUserData] = useState({});
  const GETINFO = async () => {
    const { data } = await GetMyInfo();
    setUserData(...data);
  };

  useEffect(() => {
    GETINFO();
  }, []);

  useEffect(() => {
    if (copyRef) {
      setTimeout(() => {
        setCopyRef(false);
      }, 2500);
    }
  }, [copyRef]);

  const { handleSubmit, handleChange, handleBlur, touched, values, errors } =
    useFormik({
      initialValues: {
        Password: "",
        PasswordConfirm: "",
      },
      validationSchema: Yup.object({
        Password: Yup.string().required("Password is required"),
        PasswordConfirm: Yup.string().oneOf(
          [Yup.ref("Password"), null],
          "Passwords must match"
        ),
      }),
      onSubmit: async (values) => {
        console.log(values);
        const { data } = await PanelUpdatePassword(values);

        if (data.status) {
          Swal.fire("Password Change successfull!", `${data.msg}`, "success");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          Swal.fire("Password Change Failed!", `${data.msg}`, "error");
        }
      },
    });

  return (
    <>
      <div className="flex col-span-4 xl:col-span-4 shadow-md border rounded-lg">
        <div className="py-8 px-5 w-full">
          <h2 className="text-xl lg:text-2xl  text-center sm:text-left w-full black-color">
            My Information
          </h2>

          <div className="flex w-full border-b">
            <p className="pt-10 pb-1 font-bold text-sm md:text-md lg:text-lg black-color">
              Information
            </p>
          </div>

          <div className="flex w-full">
            <div className="py-5 w-full">
              <div className="flex-col flex">
                <label className="font-normal text-sm md:text-md lg:text-lg black-color">
                  Email
                </label>
                <input
                  type="text"
                  name="Email"
                  disabled
                  className="border appearance-none rounded py-2 px-3 black-color focus:outline-[#5352ed]"
                  placeholder={userData?.Email}
                />
              </div>
            </div>
          </div>

          <div className="flex w-full">
            <div className="py-5 w-full">
              <div className="flex-col flex">
                <label className="font-normal text-sm md:text-md lg:text-lg black-color">
                  Username
                </label>
                <input
                  type="text"
                  name="Username"
                  disabled
                  className="border appearance-none rounded py-2 px-3 black-color focus:outline-[#5352ed]"
                  placeholder={userData?.Username}
                />
              </div>
            </div>
          </div>

          {/* kişisel bilgi input */}
          <form onSubmit={handleSubmit}>
            <div className="flex w-full">
              <div className="py-5 grid grid-cols-1 w-full sm:grid-cols-2 gap-8">
                <div className="flex-col flex">
                  <label className="font-normal text-sm md:text-md lg:text-lg black-color">
                    Password
                  </label>
                  <input
                    onChange={handleChange}
                    value={values.Password}
                    onBlur={handleBlur}
                    name="Password"
                    type="password"
                    className="border appearance-none rounded py-2 px-3 black-color focus:outline-[#5352ed]"
                    placeholder="Password"
                  />
                  {touched.Password && errors.Password && (
                    <span className="text-red-500 py-2">{errors.Password}</span>
                  )}
                </div>
                <div className="flex-col flex">
                  <label className="font-normal text-sm md:text-md lg:text-lg black-color">
                    New Password
                  </label>
                  <input
                    onChange={handleChange}
                    value={values.PasswordConfirm}
                    onBlur={handleBlur}
                    name="PasswordConfirm"
                    type="password"
                    className="border appearance-none rounded py-2 px-3 black-color focus:outline-[#5352ed]"
                    placeholder="New Password"
                  />
                  {touched.PasswordConfirm && errors.PasswordConfirm && (
                    <span className="text-red-500 py-2">
                      {errors.PasswordConfirm}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="flex w-full">
              <div className="py-5 pb-8 w-full">
                <button
                  type="submit"
                  className=" text-white bg-[#3742fa] hover:bg-[#5352ed] font-normal py-2 px-4 rounded"
                >
                  Update Password
                </button>
              </div>
            </div>
          </form>

          <div className="overflow-hidden bg-white shadow-md sm:rounded-lg">
            <div className="border-t border-gray-200">
              <dl>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm mt-1 font-medium text-gray-500">
                    Your Referral Code
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {userData?.Username}

                    <button
                      className="mx-auto ml-3 cursor-pointer text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-3 py-1 text-center bg-[#3742fa] p-2bg-[#3742fa] hover:bg-[#5352ed] p-2 focus:ring-primary-900"
                      onClick={() => {
                        navigator.clipboard
                          .writeText(`PayCoLife, in this system that makes you happier and more peaceful, regardless of the economic conditions of the world and countries, with 8 servers and 24/7 active robots, it automatically performs drop shipping for you.

PayCoLife is My Financial Life!

https://paycolife.com/Register/${userData?.Username}`);
                        setCopyRef(true);
                      }}
                    >
                      Copy and Share
                    </button>
                    {copyRef ? (
                      <span className="text-green-500 px-5">Copied.</span>
                    ) : null}
                  </dd>
                </div>
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    Your Active Referrals
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {userData?.Referral} User
                  </dd>
                </div>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    Your Active Servers
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {userData?.Server} Server
                  </dd>
                </div>
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    Your Available Point
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {userData?.APoint} PRC
                  </dd>
                </div>
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    Your Used Point
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    {userData?.UPoint} PRC
                  </dd>
                </div>
                <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    Available Money
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    ${userData?.Available}
                  </dd>
                </div>
                <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                  <dt className="text-sm font-medium text-gray-500">
                    Blocked Money
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                    ${userData?.Blocked}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
